import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api, apiError } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);   // null = loading, false = anon, object = user
  const [ready, setReady] = useState(false);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    // If returning from Google OAuth, let AuthCallback establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setReady(true);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const register = async (name, email, password, waiverAccepted, termsAccepted, legalName = "") => {
    const { data } = await api.post("/auth/register", { name, legal_name: legalName, email, password, waiver_accepted: !!waiverAccepted, terms_accepted: !!termsAccepted });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout, refresh: checkAuth, setUser, apiError }}>
      {children}
    </AuthContext.Provider>
  );
}
